import { FC } from 'react';
import { useTheme } from 'next-themes';
import { ImageProps } from 'components/commercetools-ui/atoms/image';
import ImageLink from 'components/commercetools-ui/atoms/ImageLink';
import { DARK, LIGHT } from 'helpers/constants/events';
import { cleanString } from 'helpers/utils/util';
import { Reference } from 'types/reference';
export interface Props {
  imageClassName?: string;
  ariaLabelLogo?: string;
  isDesktopSize: boolean;
  primaryLogoLight?: ImageProps;
  primaryLogoDark?: ImageProps;
  primaryLogoLink?: Reference;
  primaryLogoLinkMobile?: Reference;
  primaryLogoMobileDark?: ImageProps;
  primaryLogoMobileLight?: ImageProps;
}
const HeaderLogo: FC<Props> = ({
  isDesktopSize,
  primaryLogoLight,
  primaryLogoDark,
  primaryLogoLink,
  primaryLogoLinkMobile,
  primaryLogoMobileDark,
  primaryLogoMobileLight,
  ariaLabelLogo,
  imageClassName,
}) => {
  const { resolvedTheme = 'light' } = useTheme();
  return (
    <div className="mb-25 flex h-30 max-w-315 items-center justify-center md:mt-0">
      {!isDesktopSize && (
        <>
          {resolvedTheme == DARK &&
            [primaryLogoMobileDark].map((media, index) => (
              <ImageLink
                key={`${media?.alt}-${index}`}
                media={media}
                link={primaryLogoLinkMobile}
                className={imageClassName}
                title={ariaLabelLogo}
                ffid={`header-${cleanString(media?.media?.name ?? '')}`}
                marginRight={index === 0 ? '10px' : undefined}
                imageClassNames={'object-scale-down'}
                cropType='scale'
              />
            ))}
          {resolvedTheme == LIGHT &&
            [primaryLogoMobileLight].map((media, index) => (
              <ImageLink
                key={`${media?.alt}-${index}`}
                media={media}
                ffid={`header-${cleanString(media?.media?.name ?? '')}`}
                link={primaryLogoLinkMobile}
                className={imageClassName}
                title={ariaLabelLogo}
                marginRight={index === 0 ? '10px' : undefined}
                imageClassNames={'object-scale-down'}
                cropType='scale'
              />
            ))}
        </>
      )}

      {isDesktopSize && (
        <>
          {resolvedTheme == DARK &&
            [
              { media: primaryLogoDark, marginRight: '12px' },
            ].map((item, index) => (
              <ImageLink
                key={`${item?.media?.alt}-${index}`}
                media={item.media}
                link={primaryLogoLink}
                className={imageClassName}
                marginRight={item.marginRight}
                title={ariaLabelLogo}
                ffid={`header-${cleanString(item.media?.media?.name ?? '')}`}
                imageClassNames={'object-scale-down'}
                cropType='scale'
              />
            ))}
          {resolvedTheme == LIGHT &&
            [
              { media: primaryLogoLight, marginRight: '12px' },
            ].map((item, index) => {
              return (
                <ImageLink
                  key={`${item?.media?.alt}-${index}`}
                  media={item.media}
                  link={primaryLogoLink}
                  className={imageClassName}
                  marginRight={item.marginRight}
                  title={ariaLabelLogo}
                  ffid={`header-${cleanString(item.media?.media?.name ?? '')}`}
                  imageClassNames={'object-scale-down'}
                  cropType='scale'
                />
              );
            })}
        </>
      )}
    </div>
  );
};
export default HeaderLogo;
